import { render, staticRenderFns } from "./QuoteHeader.vue?vue&type=template&id=c888cf4c&scoped=true"
import script from "./QuoteHeader.vue?vue&type=script&lang=js"
export * from "./QuoteHeader.vue?vue&type=script&lang=js"
import style0 from "./QuoteHeader.vue?vue&type=style&index=0&id=c888cf4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c888cf4c",
  null
  
)

export default component.exports